const TUTOR_ENQUIRY_EMAIL = "support@mathdingo.com";
const TUTOR_ENQUIRY_SUBJECT = "Want to Become a Tutor";
const TUTOR_ENQUIRY_BODY = [
  "Hello MathDingo Team,",
  "",
  "I would like to express my interest in becoming a tutor at MathDingo.",
  "",
  "Thank you for your support. Please let me know if any further information is required.",
].join("\n");

export const TUTOR_ENQUIRY_MAILTO = `mailto:${TUTOR_ENQUIRY_EMAIL}?subject=${encodeURIComponent(
  TUTOR_ENQUIRY_SUBJECT
)}&body=${encodeURIComponent(TUTOR_ENQUIRY_BODY)}`;
